/* eslint-disable */
/* prettier-ignore */
import { useScreenSize } from '@/common-pages/hooks/size.hooks';
import globalStore from '@/services/global.state';
import theme from '@/style';
import { BasicObject } from '@/types';
import { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { scaleSize } from '@utils';

function useSize() {
  const { screenWidth, screenHeight, designWidth } = useScreenSize();
  const rightIconSize = (14 * screenWidth) / designWidth;
  const itemWidth = (102 * screenWidth) / designWidth;
  const itemHeight = (46.5 * screenWidth) / designWidth;
  const size = useMemo(() => {
    return {
      screenWidth,
      screenHeight,
      designWidth,
      rightIconSize,
      itemWidth,
      itemHeight,
    };
  }, [
    screenWidth,
    screenHeight,
    designWidth,
    rightIconSize,
    itemWidth,
    itemHeight,
  ]);
  return size;
}

export function useInnerStyle() {
  const size = useSize();

  const amountStyle = StyleSheet.create({
    opacity: {
      opacity: 0.7,
    },
  });

  const baseInputStyle = {
    minHeight: 48,
    maxHeight: 48,
    height: 48,
    padding: 0,
    fontSize: 18,
    ...theme.font.main,
    // ...theme.font.fm,
  } as BasicObject;

  const inputStyle = globalStore.isWeb
    ? {
      ...baseInputStyle,
      outline: 'none',
      caretColor: theme.fontColor.main,
    }
    : baseInputStyle;

  const inputStyles = StyleSheet.create({
    inputContainer: {
      borderBottomWidth: 0,
      backgroundColor: '#F6F6F6',
    },
    container: {
      paddingBottom: 0,
      borderRadius: 6,
    },
    error: {
      margin: 0,
      height: 0,
    },
    inputPlacehold: {}
  });

  const selectStyles = StyleSheet.create({
    item: {
      width: size.itemWidth,
      height: size.itemHeight,
    },
    itemMargin: {
      marginLeft:
        (size.screenWidth - theme.paddingSize.l * 3 - size.itemWidth * 3 - 1) /
        3,
      marginBottom:
        (size.screenWidth - theme.paddingSize.l * 3 - size.itemWidth * 3 - 1) /
        3,
    },
    inputWrap: {
      borderWidth: 1,
      borderColor: theme.backgroundColor.grey,
    },
  });

  const balanceStyles = StyleSheet.create({
    cardBg: {
      position: 'absolute',
    },
    container: {
      height: scaleSize(143),
      borderTopLeftRadius: theme.borderRadiusSize.l,
      borderTopRightRadius: theme.borderRadiusSize.l,
      overflow: 'hidden',
    },
    bgBox: {
      width: size.screenWidth - theme.paddingSize.l * 2,
      height: (459 / 1053) * (size.screenWidth - theme.paddingSize.l * 2),
    },
    balanceContainer: {
      paddingHorizontal: 20,
      paddingTop: 20,
      alignItems: 'center',
    },
    methodContainer: {
      backgroundColor: 'rgba(0,0,0,0.2)',
    },
  });

  const payMethodItemWidth = size.screenWidth - theme.paddingSize.xxl * 2;
  const payMethodStyles = StyleSheet.create({
    item: {
      width: payMethodItemWidth,
      height: 65,
    },
    itemSelected: {
      borderColor: theme.basicColor.primary,
    },
    itemNoSelectedIcon: {
      width: 18,
      height: 18,
      right: 0,
      borderRadius: 18,
      borderColor: theme.basicColor.primary,
      borderWidth: 1,
    },
    itemSelectedIcon: {
      width: 18,
      height: 18,
      right: 0,
      backgroundColor: theme.basicColor.primary,
      borderRadius: 18,
    },
    itemText: {
      color: '#333333',
      fontSize: 15
    },
  });

  return {
    size,
    amountStyle,
    inputStyle,
    inputStyles,
    selectStyles,
    payMethodStyles,
    balanceStyles,
  };
}
